<template>
  <div class="MyRes fs20">
    <div v-if="success" class="success">
      {{title['success']}}
    </div>
    <div v-if="passed && !success" class="success">
      {{title['passed']}}
    </div>
    <div v-if="!passed" class="failed">
      {{title['failed']}}
    </div>
    <div class="detail">
      <div class="note fs18">
        <div class="content" v-if="success">
          <div>
            亲爱的选手，

          </div><br><div>
            恭喜你晋级教育部白名单竞赛第二届少年硅谷  全国青少年人工智能教育成果展示大赛 - AI算法竞技赛全国决赛。你是比赛中表现最优异的500名选手之一，祝贺你！

          </div><br><div>
            AI算法竞技赛全国决赛将于2022年7月5日0:00:00开始，2022年7月28日23:59:59停止提交代码。决赛采用算法竞技场模式，考核扣哒世界计算机科学4同等难度的语法、数据结构和算法知识，比赛支持Python, C++, JavaScript三种程序语言参赛，7月28日比赛截止后竞技场排名前10%的选手，将获邀参加2022年7月30日上午10:00  11:00举行的金牌附加赛，所有入选附加赛选手要求开摄像头进行比赛。

          </div><br><div>
            AI算法竞技赛是本届少年硅谷唯一一项以代码编程算法设计为考察目标的比赛，共吸引全国31个省市自治区的10937名选手注册报名，其中7021名选手完成初赛，3097名选手晋级复赛，500名优秀选手顺利晋级全国决赛。

          </div><br><div>
            全国决赛获奖名单预计于2022年8月上旬公布，组委会将通过手机短信提醒选手登陆竞赛网站查询获奖情况并告知如何获取获奖证书等信息，敬请各位参赛选手关注 <a href="https://shaonianguigu.org.cn"> 少年硅谷AI算法竞技赛官网</a> 和扣哒世界微信公众号（扣哒世界CodeCombat）了解比赛最新动态。
          </div>
        </div>
        <div class="content" v-else>
          <div>
            亲爱的参赛选手，
          </div><br><div>
            接中国下一代教育基金会通知，第二届（2021-2022学年）少年硅谷  全国青少年人工智能教育成果大赛奖项将由中国下一代教育基金会统一公布，成绩分选拔赛成绩和全国决赛成绩，请参赛选手近期登陆网站http://snggds.cngef.org.cn 查询比赛成绩。祝你好运！
          </div>
        </div>
        <div class="badging">
            <div>
              AI算法竞技赛组委会
            </div>
            <div>
              2022年8月6日
            </div>
      </div>
      <div class="reward-image" v-if="false && passed" @click="download()">
            <canvas id="canvas" style="width: 50vw;" />
      </div>
      </div>
    <!-- <div class="info" v-if="user.realname">
         <div v-for="(v, k) in info" class="column">
         <div class="first_line">{{k}}</div>
         <div>{{v}}</div>
         </div>
         </div> -->
    <!--      <div v-else class="certify">-->
    <!--        <certify></certify>-->
    <!--      </div>-->

    </div>
  </div>
</template>

<script>
  import Certify from '@/components/score/Certify.vue'
  import MyImage from '@/components/Image.vue'
  import ProfImg from '@/assets/image/score/prof.png'
  import SealImg from '@/assets/image/score/aiyouth_seal.png'
  /* import SuccProfImg from '@/assets/image/score/succProf.jpg' */
  import qrImg from '@/assets/image/score/qrcode.jpeg'
  import finalPng from '@/assets/image/score/final.png'

  import MyButton from '@/components/Button.vue'
  import MyInput from '@/components/Input.vue';

  import 'vuejs-noty/dist/vuejs-noty.css'

  export default {
    name: 'Repe',
    props: [],
    watch: {
      fm: {
        handler() {
        },
        deep: true
      }
    },
    computed: {
      styleInput() {
        return {
          border: '1px solid #333',
          'margin-left': '-30px'
        }
      },
      orderChinese () {
        return {
        2: '一',
        3: '二',
        4: '三'
        }
      },
      qr () {
        return qrImg
      },
      finalPng () {
        return finalPng
      },
      game_year() {
        return this.$store.state.game_slug.slice(0, 4)
      },
      gameState () {
        return this.$store.state.auth.game_state[this.game_year+'-2'].state
      },
      passed () {
        return this.gameState >= 1
      },
      success () {
        return this.gameState == 1
      },
      rewardImg() {
        return ProfImg
      },
      sealImg () {return SealImg;
      },
      user() {
        return this.$store.state.auth.user;

      },
      group() {
        return ['小学组', '初中组', '大学组']
      },
      info() {
        return {
          '姓名': this.user.realname,
          '身份证号': this.user.idcard,
          '地区': this.user.area,
          '组别': this.group[this.user.group-1],
          '参赛单位': this.user.organization? this.user.organization: '个人报名'
        }
      },
      username() {
        return this.user.realname || this.user.name
      },
      title() {
        return {
          'success': '恭喜你已成功晋级全国决赛',
          'passed':  '恭喜你已成功取得省级奖项',
          'failed':'很遗憾你没有晋级'
        }
      },
      certificateUrl(){
        let redirect = `/certificates/${this.user.coco_id}?class=5d74782a64cd560026a803ab&course=560f1a9f22961295f9427742&course-instance=5d747ea564cd560026a80438`
        // let redirect = `/certificates/${this.user.coco_id}?class=5cb703db3546da005974ea29&course=560f1a9f22961295f9427742&course-instance=5cb703dbb42c5c004687cf29`
        // console.log("redirect", redirect)
        let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
        return url
      },
      ifPassedLevel(){
        return this.passed ? '你可以登陆至本次大赛竞赛平台领取你的美国大学理事会认证的' : '你可以继续完成竞技场前18个初赛学习关卡即可获得美国大学理事会认证的'
      },
    },
    data() {
      return {
        time: '11月20日',
        QQ: 'QQ群：926470859',
        reward: "计算机科学1级（CS1）证书",
        fm: {
          id: '',
        },
        error: {
          id: '',
        },
        state: '确认修改',
        code: ''
      }
    },
    methods: {
      copy() {

        navigator.clipboard.writeText(this.code).then(() => {
          this.$noty.success('复制成功!', {
            layout: 'center',
            timeout: 2000,
            progressBar: false,
            theme: 'relax',
          })
        })
      },
      checkCertify() {
        if(this.fm.id && /^[1-9]\d{5}(18|19|20|21|22)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.fm.id))
          return true;
        return false
      },
      submit() {
        this.state='修改中'
        let data = new FormData();
        data.set('idcard', this.fm.id)
        this.$http.post('/api/user/update_info', data)
            .then(res => {
              console.log(res)
              this.state='修改成功'
              let that = this
              this.$store.commit('SET_USER', res.data)
              setTimeout(function() {
                that.$router.go();
              }, 1000)
            })
            .catch(e => {
              let error = e.response.data.errors
              this.reseting = true;
              for(let e in error)
              {
                this.fm[e] = ''
                this.error[e] = error[e]
              }
              this.$nextTick(()=>{
                this.reseting = false
              })
            })
      },
      fetchCode() {
        this.$http.post('/api/user/fetch_new_code')
            .then(res => {
              this.code = res.data.code
            })
      },
      async download() {
        let can = document.getElementById("canvas")
        let blob = await new Promise(resolve=>can.toBlob(resolve));
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = '证书.png';
        a.click();
      },
      calcSN(rank) {
        let r = rank.toString()
        let len = 4-r.length;
        while(len > 0)
        {
          len -= 1;
          r = '0' + r;
        }
        return '2021' + (''+Math.random()).slice(2, 4) + r;
      }
    },
    components:{
      certify: Certify,
      my_image: MyImage,
      my_button: MyButton,
      my_input: MyInput,
    },
    mounted()
    {
      /* this.passed = !this.passed; */
      let that = this;
      this.fm.id = this.user.idcard;
      this.$http.get('/api/code/fetch')
          .then(res => {
            this.code = res.data.code
          })
      /*
         this.$http.get('/api/rank/me?round='+ this.game_year + '-1')
         .then(res => {
         let canvas = document.getElementById('canvas'),
         ctx = canvas.getContext('2d');
         let img = new Image();
         img.src = this.rewardImg;
         console.log(img)
         img.onload = () => {
         canvas.height = img.height;
         canvas.width = img.width;
         ctx.drawImage(img, 0, 0);
         ctx.font = "26pt Verdana";
         ctx.fillStyle = "#bd906c";
         ctx.fillText("童羽强"+this.username,180,308);
         ctx.fillStyle = "red";
         ctx.font = "12pt Verdana";
         ctx.fillText(this.calcSN(res.data.rank), 840, 116);
         let seal = new Image();
         seal.src = this.sealImg;
         seal.onload = () => {
         ctx.drawImage(seal, 800, 540);
         }
         }
         })
       */
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .download{
    cursor: pointer;
  }
  .MyRes, .detail{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content:center;
    position: relative;
    margin-bottom: 2vw;
  }
  .success, .failed{
    color: white;
    background-size: 60vw;
    width: 60vw;
    height: 10vw;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size: 2.3vw;
  }
  .success{
    background-image: url(~@/assets/image/score/success.png);
  }
  .failed{
    background-image: url(~@/assets/image/score/failed.png);
  }
  .info{
    background-image: url(~@/assets/image/score/bg-myinfo.png);
    background-size: 62.3vw;
    width: 62.3vw;
    height: 10.78vw;
    color: white;

    margin-top:4vw;
    box-sizing: border-box;
    padding-left: 4.375vw;
    padding-right: 5.4vw;
    padding-top:1.15vw;
    padding-bottom: 3.125vw;
    display: flex;
  }
  .column{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    border-right: solid 1px #7ec5ff;
  }
  .column:last-child{
    border-right: none !important;
  }
  .column>div{
    height: 3.25vw;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .first_line{
    border-bottom: solid 1px #7EC5FF;
    width: 100%;
  }
  .certify{
    position: absolute;
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 6.3vw 5vw 1vw 2.6vw;
    box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
    height: 100%;
  }
  .note .content p.code{
    /* color:#FE2121; */
    font-size: 28px;
    text-align: center;
  }
  span.small.code {
    font-size: 16px;
    color: #888;
  }
  .note .name{
    color: #2F2E38;
    font-weight: 600;
  }
  .note .content{
    color: #585668;
    display: flex;
    flex-direction: column;
  }
  .note .badging{
    color: #585668;
    align-self: flex-end;
  }
  .note{
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    width: 46vw;
  }
  .reward-image{
    margin-top: 3vw;
    display:flex;
    align-items:center;
    flex-direction: column;
    color: #405aee;
  }

  .important{
    font-weight: bold;
    color: #405aee;
    display: flex;
    align-items: center;
    margin-top: 1em;
    flex-direction: column;
  }
  .content{
    text-indent: 2em;
  }

</style>
